import * as mutations from './mutation-types'



// WEBPACK FOOTER //
// ./resources/score/vue/store/actions.js